var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 12",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.333 0a7.336 7.336 0 0 1 7.213 6A7.336 7.336 0 0 1 .12 6a7.336 7.336 0 0 1 7.212-6Zm0 10.667A6.004 6.004 0 0 0 13.185 6 6.003 6.003 0 0 0 1.482 6a6.003 6.003 0 0 0 5.851 4.667Zm0-1.667a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-1.333a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z"
})));
export default SvgPreview;